import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-eca-html-editor',
  templateUrl: './eca-html-editor.component.html',
  styleUrls: ['./eca-html-editor.component.scss']
})
export class EcaHtmlEditorComponent implements OnInit {
  @Input() content: string;
  @Input() isReadOnly: boolean = true;
  @Input() popoverText: string;
  @Input() isRequired: boolean;
  @Input() label: string;
  @Input() placeHolder: string = "";
  @Input() isValid: boolean = true;
  @Input() validationMessage: string = "";

  @Output() contentChange : EventEmitter<any> = new EventEmitter<any>();

  editorOptions= {
    toolbar: [['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],]
  };


  constructor() { }

  ngOnInit(): void {
  }

  onContentChanged() {
    this.contentChange.emit(this.content);
  }
}
